/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import Tabs, { TabPane } from 'rc-tabs';
import { uniqBy } from 'lodash';
import { useRequest } from 'ahooks';
import { Checkbox } from 'antd';
import { RootState } from '@/models/index';
import 'rc-tabs/assets/index.css';
import TagList from '@/components/tag-list';
import Button from '@/components/button';
import { ConIndustryTrackWebController } from '@/services/swagger/ConIndustryTrackWebController';
import styles from './index.module.scss';

const controller = new ConIndustryTrackWebController();

export default function IndustrySelectContent({ industry = [], id }) {
  const [industryId, setIndustryId] = useState(id);
  const [industryData, setIndustryData] = useState(industry);
  const dispatch = useDispatch();
  const { filterData } = useSelector<RootState, RootState['brand'] | any>(state => state.brand);
  const [selected, setSelected] = useState(filterData);
  const { run /*loading*/ } = useRequest(
    async () => {
      const { data: res } = await controller.conIndustryTrackWebControllerV1OneTrackListUsingGet1({
        industryId,
        pageIndex: 1,
        pageSize: 100,
      });
      setIndustryData(
        industryData?.map(item => ({
          ...item,
          raceTrack:
            item.originItemId === industryId
              ? res?.code === 200
                ? res?.data.list?.map(item => ({ ...item, searchItemType: 'industry' }))
                : []
              : item?.raceTrack,
          raceTrackAll:
            item.originItemId === industryId && res?.data.list?.length > 0
              ? (item.originItemId === industryId ? (res?.code === 200 ? res?.data.list : []) : item?.raceTrack)?.every(
                  d => selected?.find(unit => unit?.conIndustryTrackId === d?.conIndustryTrackId)
                )
              : !!selected?.find(unit => unit?.id === item?.originItemId),
        }))
      );
    },
    { manual: true }
  );
  useEffect(() => {
    run();
  }, [industryId, run]);
  useEffect(() => {
    setIndustryData(
      industryData?.map(unit =>
        unit.originItemId === industryId
          ? {
              ...unit,
              raceTrackAll: unit?.raceTrack
                ? unit?.raceTrack?.every(d =>
                    selected?.find(item => item?.conIndustryTrackId === d?.conIndustryTrackId)
                  )
                : unit?.raceTrackAll,
            }
          : unit
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);
  const handleChange = (value, id) => {
    let ids = [];
    if (id) {
      ids = [...selected.filter(item => id.indexOf(item.id) <= -1), ...value];
    } else {
      ids = [...selected, ...value];
    }
    setSelected(uniqBy(ids, 'id'));
  };
  const handleCheckChange = (itemData, checked, id, trackList) => {
    if (trackList && trackList?.length > 0) {
      industryData?.map(
        unit =>
          unit.originItemId === id &&
          unit?.raceTrack?.map((item: { conIndustryTrackId: string }) => {
            if (checked && selected?.find(i => i.conIndustryTrackId === item?.conIndustryTrackId)) {
              setTimeout(() => {
                document.getElementById(item?.conIndustryTrackId)?.click();
              });
            } else if (!selected?.find(i => i.conIndustryTrackId === item?.conIndustryTrackId)) {
              setTimeout(() => {
                document.getElementById(item?.conIndustryTrackId)?.click();
              });
            }
          })
      );
      setSelected(
        checked
          ? selected?.filter(item => !trackList?.find(unit => unit?.conIndustryTrackId === item.conIndustryTrackId))
          : uniqBy([...selected, ...trackList], 'conIndustryTrackId')
      );
    } else {
      if (!!selected.find(item => item?.id === itemData?.originItemId)) {
        setSelected(selected?.filter(item => item.originItemId !== itemData?.originItemId));
      } else {
        setSelected(
          uniqBy(
            [
              ...selected,
              {
                ...itemData,
                id: itemData?.originItemId,
                name: itemData?.searchItemName,
              },
            ],
            'id'
          )
        );
      }
    }
  };
  const handleConfirm = () => {
    const filterIds = uniqBy([...filterData, ...selected], 'id');
    dispatch({ type: 'brand/setFilterData', payload: filterIds.filter(item => +item.id > 0) });
    dispatch({ type: 'brand/setHasOtherCity', payload: filterIds.length > 0 });
    dispatch({ type: 'modal/close' });
  };
  const handleTabChange = originItemId => {
    setIndustryId(originItemId);
  };
  const content = useMemo(
    () => (
      <Tabs tabPosition="left" onChange={handleTabChange} defaultActiveKey={industryId}>
        {industryData?.map(item => (
          <TabPane key={item?.originItemId} tab={item?.searchItemName}>
            {/* {loading ? (
              <div className={classNames('flex-row-nowrap', 'flex-center-center', styles.industrySpin)}>
                <Spin />
              </div>
            ) : ( */}
            <div className={styles.industryTag}>
              <div className={styles.industryTagTit}>
                <Checkbox
                  checked={item?.raceTrackAll}
                  onChange={() => handleCheckChange(item, item?.raceTrackAll, item?.originItemId, item?.raceTrack)}
                >
                  {item?.searchItemName}
                </Checkbox>
              </div>
              <TagList
                list={item?.raceTrack || []}
                onChange={handleChange}
                width={94}
                fieldNames={{ label: 'conIndustryTrackId', value: 'industryTrackName', type: 'searchItemType' }}
                defaultValue={filterData.map(item => item.id)}
              ></TagList>
            </div>
            {/* )} */}
          </TabPane>
        ))}
      </Tabs>
    ),
    [filterData, handleChange, handleCheckChange, industryData, industryId]
  );
  return (
    <div className={styles.citySelect}>
      <div className={classNames('flex-row-nowrap', 'flex-between-center', styles.header)}>
        <div className={styles.title}>行业选择</div>
      </div>
      {content}
      <div className={styles.confirmBtn}>
        <Button
          width={202}
          height={40}
          type={selected && selected.length > 0 ? 'normal' : 'default'}
          disabled={!selected || selected.length === 0}
          onClick={handleConfirm}
        >
          确认选择
        </Button>
      </div>
    </div>
  );
}
